export enum EnumTipoProrrateo {
  Fijo = 1,
  Contractual,
  Consumo,
  Apantallamiento,
  Individualizado
}
